import { type FC } from 'react';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const UpdateOrderFailureModal: FC<AlertProps> = (props) => (
    <Alert
        {...props}
        title="Что-то пошло не так"
        description="Пожалуйста, перезагрузите страницу и повторите попытку"
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={() => window.location.reload()}>Перезагрузить страницу</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
